import { useSnackbar } from "notistack";
import { useEffect } from "react";

export function useClipboard(contentsHandler: (contents: string) => void) {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchClipboard = async () => {
      try {
        const clipboard = await navigator.clipboard.read();
        for (const item of clipboard) {
          for (const mimeType of item.types) {
            if (mimeType === "text/plain") {
              const blob = await item.getType("text/plain");
              const blobText = await blob.text();
              contentsHandler(blobText);
            }
          }
        }
      } catch (e) {
        console.error(e);
        enqueueSnackbar("Unable to use clipboard", { variant: "error" });
      }
    };
    fetchClipboard();
  }, [contentsHandler]);
}
